import {Type, type, Runtime} from 'main.core';
import {VSCore} from 'vsbx.core';

var formutil = {
	validateDIV: function (
		selector,
		isHideAnim = false,
		tagSelector = "[required]",
		elements = false
	) {
		let d = VS(selector), parentSelector = '.form-label';
		if (VSCore.isNodeList(d)) d = d[0];
		if (d || elements) {
			let arr = elements;
			if (!arr) arr = VS(tagSelector, d);
			for (let i = 0, l = arr.length; i < l; i++) {
				let input = arr[i];
				if (input.setCustomValidity) input.setCustomValidity("");
				if (input.tagName === "DIV") {
					if (
						$(input).find('input[type="hidden"]').length === 0 ||
						($(input).find('input[type="hidden"]').length == 1 &&
							$(input).find('input[type="hidden"]').val() == "")
					) {
						let p = $(input).parent();
						if (!isHideAnim) {
							//this.anim(p, true);
							var err = p.find("span.invalid-feedback");
							if (!err.length)
								err = p.append('<span class="invalid-feedback"></span>');
							p.find("span.invalid-feedback").html(
								$(input).data("validation-message")
							);
							p.addClass("was-validated");
							$(p).focus();
						}
						return false;
					}
				} else if (!isHideAnim && !input.reportValidity()) {
					var b = true;
					if (!isHideAnim) {
						var p = $(input).parents(parentSelector);

						if (input.type == "file") {
							if (input.name.indexOf("[") !== -1) {
								if (p.find('[type="file"]').length > 1) {
									b = false;
								}
							}
						}
						if (b) {
							if (input.validationMessage) {
								var err = p.find("span.invalid-feedback");
								if (!err.length)
									err = p.append('<span class="invalid-feedback"></span>');
								p.find("span.invalid-feedback").html(
									input.validationMessage +
										(input.type == "url" ? " " + input.placeholder : "")
								);
							}

							p.addClass("was-validated");
							if (!$(input).is(":visible")) input = input.parentNode;
							//$(input).off('change');
							$(input).on("change", function (e) {
								if (this.type !== "file" && this.value !== "") {
									p.removeClass("was-validated");
								} else if (this.type == "file" && this.files.length) {
									p.removeClass("was-validated");
								}
							});
							//this.anim(input, true);
							$(input).focus();
						}
					}
					if (b) return false;
				} else if (isHideAnim) {
					if (input.type === "checkbox") {
						if (!input.checked) return false;
					} else {
						if (input.value === "") return false;
					}
				}
				$(input).parents(parentSelector).removeClass("was-validated");
			}
		}
		return true;
	},
	getElementValue: function (el) {
		var _data = {},
			length = 0,
			files = 0;
		switch (String(el.type).toLocaleLowerCase()) {
			case "file":
				if (!!el.files) {
					if (el.multiple) _data = [];
					for (let ii = 0; ii < el.files.length; ii++) {
						files++;
						var item = {
							name: el.name,
							value: el.files[ii],
							file: true,
						};
						if (el.multiple) {
							_data.push(item);
						} else {
							_data = item;
						}
						length += el.files[ii].size;
					}
				}
				break;
			case "radio":
			case "checkbox":
				if (el.checked) {
					_data = { name: el.name, value: el.value };
					length += el.name.length + el.value.length;
				}
				break;
			case "select-multiple":
				_data = [];
				for (var j = 0; j < el.options.length; j++) {
					if (el.options[j].selected) {
						_data.push({ name: el.name, value: el.options[j].value });
						length += el.name.length + el.options[j].length;
					}
				}
				break;
			case "undefined":
				var isContentEditable = BX.parseJSON(
					el.getAttribute("contenteditable")
				);
				if (isContentEditable) {
					let v = el.innerText;
					if (el.dataset.typeValue = 'html'){
						v = el.innerHTML;
					}
					_data = { name: el.getAttribute("name"), value: v };
					length += el.getAttribute("name").length + v.length;
				}
				break;
			default:
				_data = { name: el.name, value: el.value };
				length += el.name.length + el.value.length;
				break;
		}
		return {
			data: _data,
			length: length,
			files: files,
		};
	},
	buildFormData(formData, data, parentKey) {
		let self = this;
		if (
			data &&
			typeof data === "object" &&
			!(data instanceof Date) &&
			!(data instanceof File)
		) {
			Object.keys(data).forEach((key) => {
				self.buildFormData(
					formData,
					data[key],
					parentKey ? `${parentKey}[${key}]` : key
				);
			});
		} else {
			const value = data == null ? "" : data;
			formData.append(parentKey, value);
		}
	},
	getFormData(data) {
		var formData = new FormData();
		if (type.isArray(data)) data = this.convertArrayInObject(data);
		this.buildFormData(formData, data);
		return formData;
	},
	arrayFormData(formData) {
		let arr = [];
		for (let [key, value] of formData) {
			arr.push({ name: key, value: value });
		}
		return arr;
	},
	convertArrayInObject(arr) {
		if (BX.type.isArray(arr)) {
			var a = {};
			arr.forEach(function (el) {
				a[el.name] = el.value;
			});
			return a;
		}
		return arr;
	},
	resetForm(form) {
		var self = this;
		if (VSCore.isJQueryNode(form)) {
			let tagSelector =
					':input[name]:not([type="hidden"]), select, input[type="checkbox"]',
				arr = form.find(tagSelector);
			for (let i = 0, l = arr.length; i < l; i++) {
				let input = arr[i];
				if (input.type === "checkbox") {
					input.checked = !input.checked;
				} else {
					input.value = "";
				}
			}
		}
	},
	serializeForm(el, isArray = false) {
		var self = this;
		var data = isArray ? [] : {},
			file,
			elements;
		if (VSCore.isJQueryNode(el)) {
			elements = el.find(":input");
		} else if (el.elements) {
			elements = el.elements;
		} else if (type.isFunction(el.querySelectorAll)) {
			elements = el.querySelectorAll("input[name], select[name]");
		}
		if (elements) {
			for (let i = 0, l = elements.length; i < l; i++) {
				var element = elements[i];
				var d = self.getElementValue(element);
				if (d.length) {
					// if (!d.data.name) debugger;
					if (!file && d.files > 0) file = true;
					if (isArray) {
						data.push(d.data);
					} else {
						data[d.data.name] = d.data.value;
					}
				}
			}
			if (file) data = self.getFormData(data);
			return data;
		}
		return null;
	},
};
var doc = $(document);
doc.on("click", ".form .btn-submit", function (e) {
	//debugger;
	let _this = this,
		$this = $(this),
		form = $this.parents(".form"),
		d = $this.data(),
		fD = form.data();
	if (form && formutil.validateDIV(form)) {
		BX.showWait(form[0]);
		let url = d.submitUrl
				? d.submitUrl
				: form[0].getAttribute('action')
				? form[0].getAttribute('action')
				: "/include/forms/action.php",
			data = formutil.serializeForm(form);
		let params = {
			url: url,
			type: "post",
			data: data,
			dataType: "json",
			success: function (html) {
				let data = BX.parseJSON(html);
				Runtime.loadExtension("ui.notification").then((exports) => {
          BX.UI.Notification.Center.notify({
            content: data.alert.name + '<br>' + data.alert.message,
            autoHideDelay: 4000,
						position: 'top-center'
          });
        });
				BX.closeWait(form[0]);
				formutil.resetForm(form);
			},
			error: function (xhr, status, error) {
				BX.closeWait(form[0]);
				console.log(xhr, status, error);
			},
		};
		if (BX.type.isFormData(data)) {
			params.contentType = false;
			params.processData = false;
		}

		$.ajax(params);
	}
});
doc.on("click", ".form .clean-input", function (e) {
	$(this).parent().find(".form-control").val("");
});
doc.ready(function () {
	$(":input").on("invalid", function (e) {
		e.preventDefault();
	});
});
exports.FormUtil = formutil; 